import { HotkeyNavListController } from '../../../shared/controllers/hotkey.nav.list.controller';
export default {
  template: require('./ewallet.list.html'),
  controller: HotkeyNavListController,
  controllerAs: 'EwalletListController',
  bindings: {
    downKeyDescriptionText: '<',
    items: '<',
    onItemSelected: '&',
    onItemAdded: '&',
    onItemRemoved: '&',
    selectedItem: '<',
    upKeyDescriptionText: '<'
  }
};